import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { paymentPagesFeeTypesCalculatePost } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postPaymentPagesFeeTypesCalculate = createAsyncThunk(
    'postPaymentPagesFeeTypesCalculate/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await paymentPagesFeeTypesCalculatePost(body);
            const data = response?.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_GQ_ADMIN_PAYMENT_PAGES_FEE_TYPES_CALCULATE_FAILURE',
                error: err,
                message: 'Oops! something went wrong',
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

const postPaymentPagesFeeTypesCalculateSlice = createSlice({
    name: 'postPaymentPagesFeeTypesCalculate',
    initialState,
    extraReducers: {
        [postPaymentPagesFeeTypesCalculate.pending]: (state) => {
            state.loading = true;
        },
        [postPaymentPagesFeeTypesCalculate.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
            state.error = null;
        },
        [postPaymentPagesFeeTypesCalculate.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postPaymentPagesFeeTypesCalculateSelector = (state) => state.postPaymentPagesFeeTypesCalculate;
export const postPaymentPagesFeeTypesCalculateReducer = postPaymentPagesFeeTypesCalculateSlice.reducer;
